export const LAYER_TRANSLATIONS: Record<string, Record<string, string>> = {
  BASIN_DATA_FIELRDS: {
    area: "Площа",
    date_c: "Дата",
    date_u: "Дата",
  },
  GTS_DATA_FIELDS: {
    name: "Тип",
    place: "Місце",
    river: "Річка",
    ares: "Площа",
    vol: "VOL",
    pasport_gt: "Паспорт ГТ",
    pasport_vo: "Паспорт BO",
    stan_gts: "Стан",
    regul_gts: "Регулювання",
    orend__gts: "Оренда",
    vlasn_gts: "Власник",
    dog_orenda: "Договір оренди",
  },
  HES_DATA_FIELDS: {
    Name: "Назва",
    Code: "Код ЄДРПОУ",
    Volume: "Обсяг забору чи використання води, млн. куб. м",
    Permit: "Дозвіл",
  },
  RIVER_LINE_FILEDS: {
    id: "Ідентифікатор",
    code: "Код",
    codetype: "Тип коду",
    name_ua: "Назва (укр.)",
    name_en: "Назва (англ.)",
    length: "Довжина (км)",
    basin_id: "Ідентифікатор басейну",
    area_basin: "Площа басейну (км²)",
    name_ru: "Назва (рос.)",
    subbasin_i: "Ідентифікатор суббасейну",
    bookcode: "Код книги",
    class_id: "Ідентифікатор класу",
    type_id: "Тип",
    hydrosyste: "Гідросистема",
    typehigh_i: "Тип висоти",
    typesize_i: "Тип розміру",
    geology_id: "Ідентифікатор геології",
    namebook: "Назва книги",
    date_c: "Дата створення",
    date_u: "Дата оновлення",
    prp: "PRP",
    user_id: "Ідентифікатор користувача",
  },
  WATERBODY_LINE: {
    id: "Ідентифікатор",
    name_ukr: "Назва (укр.)",
    flow_to: "Впадає в",
    type_code: "Код типу",
    length_km: "Довжина (км)",
    category: "Тип об'єкта гідрографії (озеро, ставок, водосховище, водойма тощо)",
    code_swb: "Код SWB",
    area_code: "Код площі",
    alti_code: "Код висоти",
    geo_code: "Геологічний код",
    ecodis_1: "Екодистрикт",
    ms_cd: "Код MS",
    region_cd: "Код регіону",
    system: "Система",
    alt_cat: "Категорія висоти",
    geol_cat: "Геологічна категорія",
    size_cat: "Категорія розміру",
    note_ukr: "Примітка (укр.)",
    type_name1: "Тип річки",
    ins_when: "Дата внесення",
    ins_by: "Внесено користувачем",
    modified: "Змінено",
    artificial: "Штучний об'єкт",
    basin_cd: "Код басейну",
    ecological: "Екологічний стан",
    chemical: "Хімічний стан",
    tochkovi: "Точкові забруднення",
    dyfuzni: "Дифузні забруднення",
    hydromorph: "Гідроморфологічний стан",
    ne_syntet: "Не-синтетичні забруднювачі",
    syntet: "Синтетичні забруднювачі",
    eco_1: "Екологічний індекс",
    chem_1: "Хімічний індекс",
    basin_id: "Ідентифікатор басейну",
  },
   WATERBODY_POYLINE: {
    id: "Ідентифікатор",
    name_ukr: "Назва (укр.)",
    depth_code: "Код глибини",
    type_code: "Код типу",
    depth_cut: "Глибина (кат.)",
    category: "Тип об'єкта гідрографії (озеро, ставок, водосховище, водойма тощо)",
    code_swb: "Код SWB",
    area_code: "Код площі",
    alti_code: "Код висоти",
    geo_code: "Геологічний код",
    ecodis_1: "Екодистрикт",
    ms_cd: "Код MS",
    region_cd: "Код регіону",
    system: "Система",
    alt_cut: "Категорія висоти",
    geol_cut: "Геологічна категорія",
    size_cut: "Категорія розміру",
    area: "Площа (км²)",
    type_name: "Тип водного об’єкта",
    ins_when: "Дата внесення",
    ins_by: "Внесено користувачем",
    modified: "Змінено",
    artificial: "Штучний об'єкт",
    basin_cd: "Код басейну",
    ecological: "Екологічний стан",
    chemical: "Хімічний стан",
    tochkovi: "Точкові забруднення",
    dyfuzni: "Дифузні забруднення",
    hydromorph: "Гідроморфологічний стан",
    ne_syntet: "Не-синтетичні забруднювачі",
    syntet: "Синтетичні забруднювачі",
    eco_1: "Екологічний індекс",
    chem_1: "Хімічний індекс",
    eu_cd: "Код ЄС",
    basin_id: "Ідентифікатор басейну",
    region: "Область",
    district: "Район",
    comm: "Територіальна громада",
    local: "Населений пункт",
    name: "Назва об’єкта поверхневих вод",
    type: "Тип (русловий тощо)",
    river: "Річка або басейн",
    subbasin: "Суббасейн",
    river_basi: "Річковий басейн",
    code_point: "Код точки",
    pasport_v: "Паспорт ГТС (власник)",
    pasport_r: "Паспорт ГТС (реєстрація)",
    vol: "Обʼєм (тис. м³)",
    stan_gts: "Стан ГТС",
  },
  
  MONITORING: {
    platform: "Платформа",
    name: "Назва поста",
    code: "Код",
    river_basin: "Річковий басейн",
    water_laboratory: "Водна лабораторія",
    // dataUrl: "Посилання на GeoJSON",
    lastUpdateDate: "Останнє оновлення",
    // indicators: "Показники",

    value: "Значення",
    norm: "Норма",
    title: "Назва показника",
    title_en: "Назва англійською",
    info: "Посилання на норму",
    info_en: "Інфо англійською",
    about: "Опис показника",
  },
};

export const FEATURE_TRANSLATIONS_FIELDS: {
  [key: string]: { [key: string]: string };
} = {
    "Басейн": LAYER_TRANSLATIONS["BASIN_DATA_FIELRDS"],
    "Гідротехнічні споруди для ліквідації": LAYER_TRANSLATIONS["GTS_DATA_FIELDS"],
    "ГЕС": LAYER_TRANSLATIONS["HES_DATA_FIELDS"],
    "Поверхневі води": {...LAYER_TRANSLATIONS["RIVER_LINE_FIELDS"], ...LAYER_TRANSLATIONS["WATERBODY_LINE_FIELDS"], ... LAYER_TRANSLATIONS["WATERBODY_POYLINE"]},
    "Моніторинг": LAYER_TRANSLATIONS["MONITORING"],
};
